export default __webpack_public_path__ + "static/media/pic3.3c77bcd7.jpg";